import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { obraOrcamentoAction } from '../../_actions'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  Grid,
  IconButton,
  Input,
  Paper,
  Tooltip,
  Skeleton,
  TablePagination,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { withStyles } from '@mui/styles'
import { withRouter } from 'react-router-dom'
import { history, MANUAIS_CATEGORIAS } from '../../utils'
import TitleContent from '../TitleContent'
import { useConfirm } from 'material-ui-confirm'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import { Page } from 'components'
import { useDebounce } from 'use-debounce';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(6, 6, 6, 6)
  },
  textField: {
    fontSize: 8
  }
})

const ObraOrcamento = (props) => {

  const confirm = useConfirm()
  const dispatch = useDispatch()
  const { classes, className } = props
  const { obraOrcamento } = props.obraOrcamento
  const { totalRegistros } = props.obraOrcamento
  const { isLoading } = props.obraOrcamento

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [term, setTerm] = useState('');
  const [debounceTerm] = useDebounce(term, 1000);
  const [order] = useState('data');
  const [direction] = useState('desc');
  const [ready, setReady] = React.useState(false);

  const { idOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  useEffect(() => {

    const fetchData = (page, limit, term) => {

      let filterModel = {
        Page: page,
        Limit: limit,
        Term: term,
        Order: order,
        Direction: direction,
        IdOrgao: idOrgao ? idOrgao : 0
      };

      dispatch(obraOrcamentoAction.getObraOrcamento(filterModel, true));
    };

    fetchData(page, limit, debounceTerm, order, direction);

  }, [page, limit, debounceTerm, order, direction, idOrgao]);

  useEffect(() => {

  }, [totalRegistros, isLoading]);

  useEffect(() => {
  }, [ready, props.obraOrcamento.isLoading])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClick = (id) => {
    confirm({
      title: 'Você deseja excluir esta Proposta?',
      description: 'Essa operação é irreversível',
      disabled: props.obraOrcamento.isLoading,
      confirmationText: props.obraOrcamento.isLoading ? 'Excluindo Proposta...' : 'Sim, excluir!',
      cancellationText: 'Não!'
    }).then(() => {
      dispatch(obraOrcamentoAction.deleteObraOrcamentoById(id))
    })
  }

  const handleChange = prop => event => {
    setTerm(event.target.value);
  };

  useEffect(() => {

    dispatch(obraOrcamentoAction.clear());

    let filterModel = {
      Page: page,
      Limit: limit,
      Term: term,
      Order: order,
      Direction: direction,
      IdOrgao: idOrgao ? idOrgao : 0
    };

    dispatch(obraOrcamentoAction.getObraOrcamento(filterModel, true));

  }, []);

  return (
    <Page className={classes.root} title="Propostas Enviadas">
      <AccessControl
        rule={'obrasOrcamentos.list'} //permissão necessária para acessar conteúdo
        yes={() => (
          <div>
            {undefined !== obraOrcamento && obraOrcamento.length > 0 ? (
              <TitleContent
                length={obraOrcamento.length}
                subTitle={'GERÊNCIA DE PROPOSTAS'}
                title={'Lista de Propostas Enviadas'}
                href={'/obraOrcamento'}
                telaManual={MANUAIS_CATEGORIAS.LISTAGEM_ORCAMENTO_ENVIADO}
              />
            ) : (
              <TitleContent
                length={0}
                subTitle={'GERÊNCIA DE PROPOSTAS'}
                title={'Lista de Propostas Enviadas'}
                href={'/obraOrcamento'}
                telaManual={MANUAIS_CATEGORIAS.LISTAGEM_ORCAMENTO_ENVIADO}
              />
            )}
            <Grid container spacing={3}>
              <Grid item xl={3} lg={3} md={3} xs={12}>
                <Input
                  id="term"
                  label="term"
                  placeholder="Filtro"
                  value={term}
                  fullWidth
                  onChange={handleChange('term')}
                />
              </Grid>
            </Grid>
            <br />
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Data</TableCell>
                    <TableCell>Prazo</TableCell>
                    <TableCell>Órgão</TableCell>
                    <TableCell>Obra</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Valor</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {undefined !== obraOrcamento && obraOrcamento.length
                    ? obraOrcamento.map((n) => {
                      return (
                        <TableRow hover key={n.id}>
                          <TableCell component="th" scope="row">
                            {n.id ? n.id : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.data ? moment(n.data).format("DD/MM/YYYY") : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.prazo ? moment(n.prazo).format("DD/MM/YYYY") : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.obra && n.obra.orgao ? n.obra.orgao.nome : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.obra ? '#' + n.obra.id + ' ' + n.obra.titulo : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.status == '1' ? 'APROVADO' : n.status == '2' ? 'RECUSADO' : 'PENDENTE DE ANÁLISE'}
                          </TableCell>
                          <TableCell component="th" scope="row" align="right">
                            {Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL'
                            }).format(n.valor)}
                          </TableCell>
                          <TableCell align="right">
                            <AccessControl
                              rule={'obrasOrcamentos.list'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Visualizar"
                                  component="a"
                                  onClick={() =>
                                    history.push(`/obraOrcamento/${n.id}`, n.obra.id)
                                  }
                                  size="small"
                                >
                                  <Tooltip title={'Visualizar Proposta'}>
                                    <Tooltip >
                                      <VisibilityIcon />
                                    </Tooltip>
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                          </TableCell>
                        </TableRow >
                      )
                    })
                    :
                    (
                      !isLoading ?
                        <TableRow>
                          <TableCell rowSpan={3} colSpan={8} align="center">Nenhum registro encontrado</TableCell>
                        </TableRow>
                        :
                        Array.apply(null, { length: 5 }).map((e, i) => (
                          <TableRow hover>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                          </TableRow>
                        ))
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalRegistros}
              page={page}
              labelRowsPerPage="Linhas por página"
              labelDisplayedRows={({ from, to }) => `${from}-${to} de ${totalRegistros}`}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeLimit}
            />
          </div >
        )
        }
        no={() => <AccessDenied />}
      />
    </Page >
  )
}
ObraOrcamento.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}
const connectedObraOrcamentoPage = withRouter(
  connect(mapStateToProps, null, null)(withStyles(styles)(ObraOrcamento))
)
export { connectedObraOrcamentoPage as ObraOrcamento }
